import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Footer } from "../components/Footer.js";
import { Slide_title } from "../components/slide-title.js";
import { Account_head } from "../components/account_head.js";
import { add_Baddress, billing_address_detail, Update_Baddress } from "../service/api.js";
import ErrorSnackbar from '../components/ErrorSnackbar.js';
import SuccessSnackbar from '../components/SuccessSnackbar.js';
import Head_CateHead from '../components/Head_CateHead.js';
import { AddressForm, validateAddress } from '../components/AddressForm.js';

export const Acc_Baddress = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [ExceptionError, setExceptionError] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);
    const [submitbutton, setsubmitbutton] = useState(true);
    const [validationErrors, setValidationErrors] = useState({});

    // Address fields using the AddressForm prefix convention
    const [addressValues, setAddressValues] = useState({
        billing_Company: '',
        billing_Building: '',
        billing_StreetAddress: '',
        billing_Suburb: '',
        billing_Postcode: '',
        billing_State: '',
    });

    // ── Error / Success helpers ───────────────────────────────────────────
    function handleExceptionError(res) {
        setExceptionError(prev => [...prev, { id: Date.now(), message: res }]);
    }

    function handleExceptionSuccessMessages(res) {
        setSuccessMessages(prev => [
            ...prev,
            { id: Date.now(), message: res.data.Message },
        ]);
    }

    function clearErrors(id) {
        setExceptionError(prev => prev.filter(msg => msg.id !== id));
    }

    function clearSuccess(id) {
        setSuccessMessages(prev => prev.filter(msg => msg.id !== id));
    }

    // ── Load existing address when editing ────────────────────────────────
    const data_get = async () => {
        try {
            const res = await billing_address_detail(id);
            const d = res.data.Data;
            setAddressValues({
                billing_Company: d.BCompany || '',
                billing_Building: d.BBuilding || '',
                billing_StreetAddress: d.BStreetAddress || d.BAddress1 || '',
                billing_Suburb: d.BSuburb || d.BCity || '',
                billing_Postcode: d.BPostcode || d.BZipcode || '',
                billing_State: d.BState || '',
            });
        } catch (error) {
            console.error("Error fetching billing address:", error);
        }
    };

    useEffect(() => {
        if (!localStorage.getItem('token')) {
            navigate("/signin");
        }
        if (id) {
            data_get();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ── AddressForm onChange handler ──────────────────────────────────────
    const handleAddressChange = (fieldName, value) => {
        setAddressValues(prev => ({ ...prev, [fieldName]: value }));
        setValidationErrors(prev => ({ ...prev, [fieldName]: undefined }));
    };

    // ── Submit ────────────────────────────────────────────────────────────
    const handleSubmit = async (event) => {
        event.preventDefault();

        const errors = validateAddress(addressValues, "billing");
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            return;
        }
        setValidationErrors({});
        setsubmitbutton(false);

        const payload = {
            BCompany: addressValues.billing_Company,
            BBuilding: addressValues.billing_Building,
            BStreetAddress: addressValues.billing_StreetAddress,
            BSuburb: addressValues.billing_Suburb,
            BPostcode: addressValues.billing_Postcode,
            BState: addressValues.billing_State,
        };

        if (id) {
            const res = await Update_Baddress(payload, id);
            if (res.status === 200) {
                handleExceptionSuccessMessages(res);
                navigate("/account");
            } else {
                setsubmitbutton(true);
                handleExceptionError(res.response?.data?.ErrorMessage || "Update failed");
            }
        } else {
            const res = await add_Baddress(payload);
            if (res.status === 200) {
                handleExceptionSuccessMessages(res);
                navigate("/account");
            } else {
                setsubmitbutton(true);
                handleExceptionError(res.response?.data?.ErrorMessage || "Save failed");
            }
        }
    };

    return (
        <div>
            <ErrorSnackbar errorMessages={ExceptionError} onClearErrors={clearErrors} />
            <SuccessSnackbar successMessages={successMessages} onclearSuccess={clearSuccess} />
            <Head_CateHead />
            <Account_head />
            <div className="sign_in_wrapper container account">
                <div className="container sign_container">
                    <Slide_title title={id ? "Edit Billing Address" : "Add Billing Address"} className="add_address_page_title" />
                    <div className="sign_up_wrapper">
                        <form onSubmit={handleSubmit} noValidate>
                            <AddressForm
                                prefix="billing"
                                values={addressValues}
                                errors={validationErrors}
                                onChange={handleAddressChange}
                            />
                            <br />
                            <div className="order_box_delete">
                                {submitbutton ? (
                                    <button style={{ backgroundColor: '#01AEF0' }} type="submit">
                                        {id ? "Update" : "Add"}
                                    </button>
                                ) : (
                                    <button style={{ backgroundColor: '#01AEF0' }} type="button" disabled>
                                        Saving…
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};
